import { AsYouType } from 'libphonenumber-js'

export const formatPhone = (str: string): string => {
  if (str[0] === '1') return ''
  if (str.length === 4) return str.replace(/\D+/, '')
  const phoneFormatter = new AsYouType('US')
  if (str.length > 14) return str.substr(0, 14)
  return phoneFormatter.input(str)
}
